export default function Section2() {
  const list = [
    "Answer calls, return emails, and similar tasks",
    "Provide various levels of customer service",
    "Type documents, mail letters, and take notes",
    "Collaborate with writers, graphic artists, and designers",
    "Find and engage potential customers",
    "Advise on best business practices",
  ];

  return (
    <div className="Section2 bg-[#F5F5F5] py-[35px]">
      <div className="container-1280 section2-container mx-auto w-full px-[15px] md:w-[750px] lg:w-[970px] min-[1150px]:w-[100%]">
        <div className=" bg-white flex flex-col min-[1150px]:flex-row rounded-[3px] p-[15px_20px_20px_30px] border border-solid border-[#b3b3b3]">
          <div className="md:m-[20px] lg:m-0 lg:w-[90%] min-[1150px]:w-1/2">
            <div className="">
              <h1 className="text-[24px] md:text-[34px] font-bold my-[0.67em] text-[#DA2128] leading-[32px] md:leading-[40px]">
                Virtual Assistant
              </h1>

              <p className="text-[16px] font-open text-[#535353] mb-5">
                We provide virtual assistance to those who need to engage and
                respond to customers’ queries and potential customers through
                various mediums. From answering emails to interacting clients
                across social media platforms, we provide it all. Our VA’s have
                excellent communication skills and deliver prompt replies to
                customers whenever needed. Major part of a virtual assistant
                consists of:
              </p>

              <ul className="my-[25px]">
                {list.map((item, index) => {
                  return (
                    <li
                      key={index}
                      className="bg-[url('/public/assets/tick-image-va.png')] bg-left-center bg-no-repeat pl-[50px]"
                    >
                      <h4 className="mb-[5px] mt-5 font-[600] text-[#323232] text-[14px] leading-[1.3] font-open">
                        {item}
                      </h4>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>

          <div className="min-[1150px]:w-[60%] p-[10px_16px_0_10px]">
            <img className="w-full md:w-[90%] lg:w-[70%] mx-auto min-[1150px]:w-auto rounded-tr-[5px] rounded-tl-[5px] shadow-[0_0px_9px_0px_rgb(0_0_0/0.4)]" src="/assets/va-image-va.png"></img>
          </div>
        </div>
      </div>
    </div>
  );
}
